var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDependencies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.668,
    height: 10,
    viewBox: "0 0 31.668 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2068",
    "data-name": "Group 2068",
    transform: "translate(5555.242 23393.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2067",
    "data-name": "Group 2067",
    transform: "translate(2.008 30.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.75,5.5A.755.755,0,0,1,4,4.75V1.5H.75A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0h4A.755.755,0,0,1,5.5.75v4A.755.755,0,0,1,4.75,5.5Z",
    transform: "translate(-5539.472 -23423.389) rotate(45)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.75,5.5h-4A.755.755,0,0,1,0,4.75v-4A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75V4H4.75a.75.75,0,0,1,0,1.5Z",
    transform: "translate(-5543.361 -23423.389) rotate(45)",
    fill: "#061133"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M7.02,10H2.98C.97,10,0,9.11,0,7.27V2.73C0,.89.98,0,2.98,0H7.02C9.03,0,10,.89,10,2.73V7.26C10,9.11,9.02,10,7.02,10ZM2.98,1.5c-1.34,0-1.48.38-1.48,1.23V7.26c0,.86.14,1.23,1.48,1.23H7.02c1.34,0,1.48-.38,1.48-1.23V2.73c0-.86-.14-1.23-1.48-1.23Z",
    transform: "translate(-5555.242 -23393.75)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M7.02,10H2.98C.97,10,0,9.11,0,7.27V2.73C0,.89.98,0,2.98,0H7.02C9.03,0,10,.89,10,2.73V7.26C10,9.11,9.02,10,7.02,10ZM2.98,1.5c-1.34,0-1.48.38-1.48,1.23V7.26c0,.86.14,1.23,1.48,1.23H7.02c1.34,0,1.48-.38,1.48-1.23V2.73c0-.86-.14-1.23-1.48-1.23Z",
    transform: "translate(-5533.574 -23393.75)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M.75,19.5A.755.755,0,0,1,0,18.75V12.271a.755.755,0,0,1,.75-.75.755.755,0,0,1,.75.75V18.75A.749.749,0,0,1,.75,19.5Z",
    transform: "translate(-5524.176 -23389.5) rotate(90)",
    fill: "#061133"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDependencies);
export default __webpack_public_path__ + "static/media/Icon-dependencies.c79fa1fb4038017b79aad301cef8558c.svg";
export { ForwardRef as ReactComponent };